import { render, staticRenderFns } from "./ComponentForm.vue?vue&type=template&id=fbe79734"
import script from "./ComponentForm.vue?vue&type=script&lang=js"
export * from "./ComponentForm.vue?vue&type=script&lang=js"
import style0 from "./ComponentForm.vue?vue&type=style&index=0&id=fbe79734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports